import { render, staticRenderFns } from "./DatiCatastali.vue?vue&type=template&id=080221f7"
import script from "./DatiCatastali.vue?vue&type=script&lang=ts"
export * from "./DatiCatastali.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports